// Card descriptions are TipTap HTML. Older ones are plain text, one paragraph per line.

// A description as one line of plain text, for previews and the Forge
export function htmlToText(value: string | null): string {
    const text = String(value || '');
    if(!/^\s*</.test(text)) {
        return text.trim();
    }
    // DOMParser's document is inert: nothing in it loads or runs
    const doc = new DOMParser().parseFromString(text.replace(/<\/(p|li|h\d|blockquote)>/gi, '$& '), 'text/html');
    return (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
}
